import { createSlice } from '@reduxjs/toolkit';
import { filterServerOnlyConfigs } from '@a1/shared';
import defaultAppConfig from 'constants/appConfig';

export const initialState = {
  data: defaultAppConfig
};

const appConfigSlice = createSlice({
  name: 'appConfig',
  initialState,
  reducers: {
    // Dialogs post this whole copy back to the merge endpoint, which would write a held server-only value back stale.
    setAppConfigData: (state, action) => {
      state.data = filterServerOnlyConfigs(action.payload.data);
    },
    // setBookingConfirmationText: (state, action) => {
    //   state.data.bookingConfirmationText = action.payload;
    // },
    // setAffiliateBookingConfirmationText: (state, action) => {
    //   state.data.bookingAffiliateConfirmationText = action.payload;
    // },
    // setCancelledBookingText: (state, action) => {
    //   state.data.cancelledBookingText = action.payload;
    // },
    // setDidNotAttendBookingText: (state, action) => {
    //   state.data.didNotAttendBookingText = action.payload;
    // },
    // setRescheduledBookingText: (state, action) => {
    //   state.data.rescheduledBookingText = action.payload;
    // },
    // setReminderBookingText: (state, action) => {
    //   state.data.reminderBookingText = action.payload;
    // },
    setHelpText: (state, action) => {
      state.data.helpText = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  setAppConfigData,
  // setBookingConfirmationText,
  // setCancelledBookingText,
  // setAffiliateBookingConfirmationText,
  // setDidNotAttendBookingText,
  // setRescheduledBookingText,
  // setReminderBookingText,
  setHelpText
} = appConfigSlice.actions;

export default appConfigSlice.reducer;
